<template>
    <div class="battery-container">
      <div class="battery-body">
        <div
          class="battery-level"
          :style="{ width: batteryWidth, backgroundColor: batteryColor }"
        ></div>
      </div>
      <div class="battery-head"></div>
      <!-- <span class="battery-text">{{ batteryLevel }}%</span> -->
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue'
  
  const props = defineProps({
    batteryLevel: {
      type: Number,
      required: true,
      validator: (v) => v >= 0 && v <= 100,
    },
  })

  console.log("battery:", props.batteryLevel)
  
  const batteryWidth = computed(() => `${props.batteryLevel}%`)
  
  const batteryColor = computed(() => {
    if (props.batteryLevel > 60) return '#4caf50'  // 绿色
    if (props.batteryLevel > 30) return '#ffc107'  // 橙色
    return '#f44336'                                // 红色
  })
  </script>
  
  <style scoped>
  .battery-container {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  
  .battery-body {
    width: 60px;
    height: 24px;
    border: 2px solid #333;
    border-radius: 4px;
    position: relative;
    margin-right: 6px;
    box-sizing: border-box;
    background-color: #ddd;
    overflow: hidden;
  }

  .battery-level {
    height: 100%;
    transition: width 0.3s, background-color 0.3s;
  }

  .battery-head {
    width: 6px;
    height: 14px;
    background-color: #333;
    margin-left: -4px;
    border-radius: 2px;
  }

  .battery-text {
    margin-left: 4px;
    font-weight: bold;
  }
  </style>
  